import { defineStore } from "pinia";
type MessageDetails = {
  type: "info" | "error" | "success" | "warning";
  showReload: boolean;
  autoHide: boolean;
  title: string;
  message: string;
};

interface State {
  messageDetail?: MessageDetails;
}
export const useMessageStore = defineStore("message", {
  scope: "global",
  state: (): State => ({ messageDetail: undefined }),
  getters: {
    show(): boolean {
      return this.messageDetail != null && !!(this.messageDetail.message || this.messageDetail.title);
    },
  },
  actions: {
    updateMessage(details: MessageDetails) {
      this.messageDetail = details;
    },
    clearMessage() {
      this.$reset();
    },
  },
});
